import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.WhoDidTheJob = {
  validator: '',

  component: React.createClass({
    componentDidMount: function() {
      const closureData = Job.Data.closureSurvey

      $('#business-radio-group').radioButtonGroup({activeRowClass: 'active'})
    },

    previous: function() {
      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.HasJobBeenDoneYet)
    },

    autoProgressSelectedBusiness: function(e, businessName) {
      const outcome = Job.Data.closureSurvey.outcome
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
      
      Job.Actions.updateClosureSurvey({
        job: Job.Data.closureSurvey.job,
        possibleBusinesses: Job.Data.closureSurvey.possibleBusinesses,
        outcome: outcome,
        providerAccountId: $selectedItem.value,
        providerAccountName: businessName,
        rating: null,
        comments: null,
        selectedReasons: [],
        value: Job.Data.closureSurvey.value
      })

      if (Job.Data.closureSurvey.outcome === "going_ahead") {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SubmitFeedback)
      }
      else {
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.RateExperience)
      }
    },

    autoProgressOtherOptions: function(e) {
      const $selectedItem = $(e.currentTarget).find('[type="radio"]')[0]
     
      Job.Actions.updateClosureSurvey({
        job: Job.Data.closureSurvey.job,
        possibleBusinesses: Job.Data.closureSurvey.possibleBusinesses,
        outcome: $selectedItem.value,
        providerAccountId: null,
        providerAccountName: null,
        rating: null,
        comments: null,
        selectedReasons: [],
        value: Job.Data.closureSurvey.value
      })

      JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.SubmitFeedback)
    },

    render: function() {
      return (
        <div>
          <h3 className="mb15 mt20">{Job.Data.closureSurvey.outcome === "going_ahead" ? "Have you chosen a business to do the work?" : "Who did the job?"}</h3>
          <div className="form-group">
            <div className="radio-button-box minor-bold" id="business-radio-group">
              { Job.Data.closureSurvey.possibleBusinesses.map((business) => {
                  return (
                    <div key={business.id} className="radio" onClick={(e) => this.autoProgressSelectedBusiness(e, business.business_name)}>
                      <div className="row">
                        <div className="col-xs-10 col-sm-10 bold">{business.business_name}</div>
                        <div className="col-xs-10 col-sm-10 font-12">{business.mobile_phone}</div>
                        <input type="radio" id={business.id} name="provider_account_id" value={business.id} className="form-control invisible"/>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            { Job.Data.closureSurvey.outcome === "going_ahead" &&
              <div className="radio-button-box minor-bold pt30" id="outcome-radio-group">
                <div className="radio" onClick={this.autoProgressOtherOptions}>
                  <div className="row">
                    <div className="col-xs-10 col-sm-10 bold">I'm still deciding who to hire</div>
                    <input type="radio" id="going_ahead" name="outcome" value="going_ahead" className="form-control invisible"/>
                  </div>
                </div>
              </div>
            }
            <div className="radio-button-box minor-bold pt30" id="outcome-radio-group">
              <div className="radio" onClick={this.autoProgressOtherOptions}>
                <div className="row">
                  <div className="col-xs-10 col-sm-10 bold">A business from outside ServiceSeeking.com.au</div>
                  <input type="radio" id="job_completed_externally" name="outcome" value="job_completed_externally" className="form-control invisible"/>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className='col-sm-6 col-xs-6 pl18'>
              <a href="#" className="btn btn-block btn-clear" onClick={this.previous}>
                <i className='ficon-arrow-left-shaft pr10 fs14' />
                Back
              </a>
            </div>
          </div>
        </div>
      )
    }
  })
}

